'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/11/11.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link } from 'react-router';

var LeftNavButton = function (_Component) {
  (0, _inherits3.default)(LeftNavButton, _Component);

  function LeftNavButton() {
    (0, _classCallCheck3.default)(this, LeftNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(LeftNavButton).apply(this, arguments));
  }

  (0, _createClass3.default)(LeftNavButton, [{
    key: 'render',
    value: function render() {
      var styles = require('./CarouselOfDetailWithLink.scss');
      return _react2.default.createElement('a', (0, _extends3.default)({}, this.props, { className: styles.flexPrev }));
    }
  }]);
  return LeftNavButton;
}(_react.Component);

var RightNavButton = function (_Component2) {
  (0, _inherits3.default)(RightNavButton, _Component2);

  function RightNavButton() {
    (0, _classCallCheck3.default)(this, RightNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(RightNavButton).apply(this, arguments));
  }

  (0, _createClass3.default)(RightNavButton, [{
    key: 'render',
    value: function render() {
      var styles = require('./CarouselOfDetailWithLink.scss');
      return _react2.default.createElement('a', (0, _extends3.default)({}, this.props, { className: styles.flexNext }));
    }
  }]);
  return RightNavButton;
}(_react.Component);

var CarouselOfDetailWithLink = (_temp = _class = function (_Component3) {
  (0, _inherits3.default)(CarouselOfDetailWithLink, _Component3);

  function CarouselOfDetailWithLink() {
    (0, _classCallCheck3.default)(this, CarouselOfDetailWithLink);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(CarouselOfDetailWithLink).apply(this, arguments));
  }

  (0, _createClass3.default)(CarouselOfDetailWithLink, [{
    key: 'render',
    value: function render() {
      var styles = require('./CarouselOfDetailWithLink.scss');
      var dotClass = 'slick-dots ' + styles.dotsClass;
      var settings = {
        dots: true,
        infinite: true,
        arrows: true,
        dotsClass: dotClass,
        fade: false,
        speed: 1500,
        autoplay: false,
        // autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: true,
        prevArrow: _react2.default.createElement(LeftNavButton, this.props),
        nextArrow: _react2.default.createElement(RightNavButton, this.props)
      };
      var _props = this.props;
      var images = _props.images;
      var goeasyStyle = _props.goeasyStyle;

      var content = '';
      if (images instanceof Array) {
        if (images.length > 1) {
          content = _react2.default.createElement(
            _reactSlick2.default,
            (0, _extends3.default)({ className: styles.carousel, style: (0, _extends3.default)({}, goeasyStyle) }, settings),
            images.map(function (image, index) {
              return _react2.default.createElement(
                'div',
                { key: index, className: styles.childItem },
                _react2.default.createElement('img', { className: styles.img, title: image.name, alt: '', src: image.img })
              );
            })
          );
        } else if (images.length === 1) {
          content = _react2.default.createElement(
            'div',
            { className: styles.childItem },
            _react2.default.createElement('img', { className: styles.img, title: images[0].name, alt: '', src: images[0].img })
          );
        }
      }
      return content;
    }
  }]);
  return CarouselOfDetailWithLink;
}(_react.Component), _class.propTypes = {
  images: _react.PropTypes.array.isRequired,
  goeasyStyle: _react.PropTypes.object
}, _temp);
exports.default = CarouselOfDetailWithLink;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarouselOfDetailWithLink/CarouselOfDetailWithLink.js
 ** module id = 1317
 ** module chunks = 0
 **/